import React, { useEffect, useState } from 'react';
import FormModal from '../../components/Modals/FormModal';
import InputField from '../../components/Forms/Input/InputField';
import { useDocumentSequence } from '../../hooks/document/useDocumentSequence';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const DocumentSequenceEditPopup: React.FC<Props> = ({ isOpen, onClose }) => {
  const { detail, handlerUpdateCurrentNumber, isSubmitting } = useDocumentSequence();

  const [currentNumber, setCurrentNumber] = useState<string>(''); // ← INPUT LIBRE

  useEffect(() => {
    if (detail && isOpen) {
      setCurrentNumber(String(detail.currentNumber ?? ''));
    }
  }, [detail, isOpen]);

  const handleSubmit = () => {
    if (!detail?.id) return;

    // ❌ Si está vacío → no mandar update
    if (currentNumber.trim() === '') return;

    const numericValue = Number(currentNumber);

    // ❌ Si no es número válido → no mandar
    if (isNaN(numericValue) || numericValue < 0) return;

    handlerUpdateCurrentNumber(detail.id, numericValue);
  };

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title="Actualizar Correlativo"
      maxWidth="max-w-sm"
    >
      <div className="mt-4">

        <InputField
          label="Nuevo correlativo"
          name="currentNumber"
          type="text" // ← IMPORTANTE: permitir limpiar sin forzar número
          iconKey="hash"
          value={currentNumber}
          onChange={(e) => setCurrentNumber(e.target.value)}
          placeholder="Ingresa un número"
        />

        <button
          disabled={isSubmitting}
          onClick={handleSubmit}
          className="mt-6 w-full rounded bg-primary px-4 py-2 text-white hover:bg-opacity-90"
        >
          Actualizar
        </button>

      </div>
    </FormModal>
  );
};

export default DocumentSequenceEditPopup;
